import { create } from 'zustand';
import { getActions } from './actions.js';
import { AuthLayout } from '../../types/modalProps.js';
const DEFAULT_THEME = {
    isDark: false,
    logo: undefined,
    appName: undefined,
    bareModal: false,
    embeddedModal: false,
    oAuthLogoVariant: undefined,
    authLayout: [AuthLayout.AUTH_FULL, AuthLayout.EXTERNAL_FULL],
};
export const useThemeStore = create((set, get) => (Object.assign(Object.assign({}, DEFAULT_THEME), getActions(set, get))));
